import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { useWorkoutStore } from "@/state/workout-store";

/**
 * Session chrome around the HUD: the live form feedback banner. The round timer
 * lives inside the HUD; the Give Up control lives in the bottom-right control
 * cluster.
 */
export function WorkoutConsole() {
  const lastFeedback = useWorkoutStore((s) => s.lastFeedback);
  const lastFeedbackType = useWorkoutStore((s) => s.lastFeedbackType);

  return (
    <>
      {/* Form feedback banner */}
      {lastFeedback && (
        <div
          className={`absolute bottom-28 left-1/2 w-[min(92vw,32rem)] -translate-x-1/2 rounded-xl border px-4 py-3 text-sm font-medium backdrop-blur-md ${
            lastFeedbackType === "form-error"
              ? "border-red-500/30 bg-red-950/60 text-red-200"
              : "border-emerald-500/30 bg-emerald-950/60 text-emerald-200"
          }`}
        >
          <div className="flex items-start gap-2.5">
            {lastFeedbackType === "form-error" ? (
              <AlertTriangle className="mt-0.5 size-4 shrink-0" />
            ) : (
              <CheckCircle2 className="mt-0.5 size-4 shrink-0" />
            )}
            <span>{lastFeedback}</span>
          </div>
        </div>
      )}
    </>
  );
}
